import httpClient from '@/api/httpClient'
import { defineStore } from 'pinia'
import store from '@/store'

export const useUsersStore = defineStore('users', {
  state: () => ({
    users: [],
    fetchInitiated: false
  }),

  getters: {
    allAsObject: (state) => {
      const obj = {}
      state.users.forEach(user => { obj[user.name] = user.id })
      return obj
    },

    forId: (state) => (id) => {
      return state.users.find(user => user.id === id)
    }
  },

  actions: {
    async fetch() {
      this.fetchInitiated = true

      return httpClient.get('/api/internal/users')
        .then(response => {
          this.users = response.data.users
        })
        .catch((err) => {
          store.dispatch('messages/smartAdd', err)
        })
    },

    async fetchOnce() {
      if (this.fetchInitiated) return Promise.resolve()

      return this.fetch()
    }
  }
})
